import { ensureObject, ensureString } from "../../validate";
import { fetchJson } from "./http";
import {
  COURSES_BASE_URL,
  CoursesApiError,
  type CourseListResponse,
  type SummaryParams,
} from "./types";

const FN = "GZIntegracoes.v1.cursos.summary";

/**
 * Lista as aulas de uma turma em modo prévia — **sem** URLs de vídeo
 * (`url-video` sempre `null`). Público, não precisa de autenticação.
 */
export async function summary(params: SummaryParams): Promise<CourseListResponse> {
  ensureObject(params, `${FN}(params)`);
  ensureString(params.className, `${FN} → params.className`);
  ensureString(params.courseName, `${FN} → params.courseName`);

  const query = new URLSearchParams({
    className: params.className,
    courseName: params.courseName,
  });

  const { status, ok, body } = await fetchJson(
    `${COURSES_BASE_URL}/summary?${query.toString()}`,
  );

  if (!ok) {
    throw new CoursesApiError(
      `${FN}: resposta inesperada da API (status ${status}).`,
      status,
      body,
    );
  }

  return body as CourseListResponse;
}
